import { useEffect } from "react";
import { PRODUCT_NAME } from "../titles";

export const useBrowserTitle = (
  title: string,
  rollbackTitleOnUnmount?: boolean
) => {
  useEffect(() => {
    const previousDocumentTitle = document.title;
    document.title = title;
    return () => {
      document.title = rollbackTitleOnUnmount
        ? previousDocumentTitle
        : PRODUCT_NAME;
    };
  }, [title]);
};
